import React, { Component } from "react";
import { Map, GoogleApiWrapper, InfoWindow, Marker } from "google-maps-react";
import HTTP from "../../services/httpService";
import CustomHeader from "../common/Header";
import { Card } from "antd";
import upcomingHotelLocation from "./upcoming.png";

const removeLiveHotelIds = [215, 227, 246, 247, 258];
const mapStyles = {
    width: "97.5%",
    height: "100vh",
};

class MapContainer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            hotelData: [],
            upcomingHotelData: [],
            countKey: "",
            showingInfoWindow: false, // Hides or shows the InfoWindow
            activeMarker: {}, // Shows the active marker upon click
            selectedPlace: {}, // Shows the InfoWindow to the selected place upon a marker
        };
        this.staff_id = localStorage.getItem(`x-dashboard-staffid`);
    }

    onMarkerClick = (props, marker, e) =>
        this.setState({
            selectedPlace: props,
            activeMarker: marker,
            showingInfoWindow: true,
        });

    onClose = (props) => {
        if (this.state.showingInfoWindow) {
            this.setState({
                showingInfoWindow: false,
                activeMarker: null,
            });
        }
    };

    async componentDidMount() {
        const formData = { staff_id: this.staff_id };

        let { data: hotelListOptions } = await HTTP(
            "/dashboard/getMapHotels",
            formData,
        );
        hotelListOptions.map(
            (e) => (e.coordinates = [e.latitude, e.longitude]),
        );
        hotelListOptions.filter((e) => e.latitude !== 0 && e.longitude !== 0);
        let updated = hotelListOptions.filter((e) => {
            if (removeLiveHotelIds.includes(e.hotel_id)) {
                return false;
            }
            return true;
        });

        // const { data: upcomingHotelList } = await HTTP(
        //     "/dashboard/getUpcomingHotels",
        //     formData,
        // );
        // upcomingHotelList.map(
        //     (e) => (e.coordinates = [e.latitude, e.longitude]),
        // );
        // upcomingHotelList.filter((e) => e.latitude !== 0 && e.longitude !== 0);

        this.setState({
            // upcomingHotelData: upcomingHotelList,
            hotelData: updated,
        });
    }

    showMapPins = async (formData) => {
        if (this.state.showingInfoWindow) {
            this.setState({
                showingInfoWindow: false,
                activeMarker: null,
            });
        }
        if (formData.data_for === "total_hotel") {
            this.setState({
                countKey: "",
            });
        } else {
            this.setState({
                countKey: formData.data_for,
            });
        }
        const { data: hotelMapCoordinates } = await HTTP(
            "/dashboard/getDashboardData",
            {
                ...formData,
                staff_id: this.staff_id,
                hotel_type: "all",
            },
        );

        if (formData.data_for === "hotel_address") {
            hotelMapCoordinates.map((e) => {
                e.hotel_address = `${e.street.trim()}, ${e.city.trim()}, ${e.state.trim()}-${e.zipcode.trim()} `;
                return e;
            });
        }

        // const { data: upcomingHotelMapCoordinates } = await HTTP(
        //     "/dashboard/getUpcomingHotels",
        //     { staff_id: this.staff_id },
        // );
        // if (formData.data_for === "hotel_address") {
        //     upcomingHotelMapCoordinates.map((e) => {
        //         e.hotel_address = `${e.street}, ${e.city}, ${e.state}-${e.zip_code} `;
        //         return e;
        //     });
        // }

        this.setState({
            hotelData: hotelMapCoordinates,
            // upcomingHotelData: upcomingHotelMapCoordinates,
        });
    };

    render() {
        return (
            <Card className="dashboard-container">
                <CustomHeader callDataAPI={this.showMapPins} />
                <Map
                    google={this.props.google}
                    zoom={5}
                    style={mapStyles}
                    className="map-container"
                    initialCenter={{
                        lat: 41.850033,
                        lng: -87.6500523,
                    }}
                >
                    {this.state.hotelData.length > 0 &&
                        this.state.hotelData.map((e) => {
                            return (
                                <Marker
                                    onClick={this.onMarkerClick}
                                    key={e.hotel_id}
                                    position={{
                                        lat: e.latitude,
                                        lng: e.longitude,
                                    }} // latitude: "35.8993832" longitude: "-75.6091696"
                                    name={e.hotel_name}
                                    countKey={e[this.state.countKey]}
                                    // icon={liveHotelLocation}
                                />
                            );
                        })}
                    {/* {this.state.upcomingHotelData.length > 0 &&
                        this.state.upcomingHotelData.map((e) => {
                            return (
                                <Marker
                                    onClick={this.onMarkerClick}
                                    key={e.hotel_id}
                                    position={{
                                        lat: e.latitude,
                                        lng: e.longitude,
                                    }}
                                    name={e.name}
                                    countKey={e.hotel_address}
                                    icon={upcomingHotelLocation}
                                />
                            );
                        })} */}
                    <InfoWindow
                        marker={this.state.activeMarker}
                        visible={this.state.showingInfoWindow}
                        onClose={this.onClose}
                    >
                        <div>
                            <strong style={{ margin: "5px" }}>
                                {this.state.selectedPlace.name}
                            </strong>
                            {this.state.countKey && (
                                <strong>
                                    {this.state.countKey === "hotel_address"
                                        ? `Location :  ${this.state.selectedPlace.countKey}`
                                        : `Counts :  ${
                                              this.state.selectedPlace
                                                  .countKey || 0
                                          }`}
                                </strong>
                            )}
                        </div>
                    </InfoWindow>
                </Map>
            </Card>
        );
    }
}

export default GoogleApiWrapper({
    apiKey: "AIzaSyByc24dkTLAGXtypDyT5pRcwbgj6KKNyvo",
})(MapContainer);
